import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/workflow/filters";
import filters from "../../models/workflow/filters";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    filters: [],
    edit: [],
    new: [],
    deleteItem: [],
    filter:{}
  },

  mutations: {
    setFilters(state, data) {
      state.filters = data;
    },

    setEdit(state, data) {
      state.edit = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data
    },
    setFilter(state,data){
      state.filter=data
    }
   
  
  },
  actions: {
    async getfilters(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getAllFilters();
          state.commit("setFilters",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getfilter(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getFilter();

          state.commit("setFilter",  item );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

      async edit(state) {
        return new Promise(async (resolve, reject) => {
          try {
            await state.state.service.edit(state.state.edit).then(() => {
              let item = state.state.edit
              let options = state.state.filters
              options = options.map((option)=>{
              if(option.operId != item.operId){
                return option
              }
              item = filters.fromJson({
                  operId:item.operId,
                  fecDesde:item.from,
                  fecHasta:item.to,
                  mios:item.mios,
                  pendientes:item.pending,
                  aprobadas:item.approved,
                  rechazadas:item.rejected,
                  licencias:item.licenses,
                  cHorario:item.cSchedule,
                  hsExtra:item.hsExtra,
                  licF:item.licF,
                  dele:item.dele,
                  Nombre:item.name,
                  columnas:item.columnas
              })
              return item
              })
              state.commit('setFilters', options)
              resolve(true)
            })
          }
          catch (error) {
            reject(error)
          }
        })

      },
      async new(state) {
        return new Promise(async (resolve, reject) => {
          try {
            await state.state.service.new(state.state.new).then((data) => {
              let item = state.state.new
              let options = state.state.filters
              let newItem = filters.fromJson({
                  operId:item.operId,
                  fecDesde:item.from,
                  fecHasta:item.to,
                  mios:item.mios,
                  pendientes:item.pending,
                  aprobadas:item.approved,
                  rechazadas:item.rejected,
                  licencias:item.licenses,
                  cHorario:item.cSchedule,
                  hsExtra:item.hsExtra,
                  licF:item.licF,
                  dele:item.dele,
                  Nombre:item.name
              })
              options.push(newItem);
              state.commit('setFilters', options)
              resolve(true)
            })
          }
          catch (error) {
            reject(error)
          }
        })

    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
       await state.state.service.delete(state.state.deleteItem).then(() => {
        let options = state.state.filters
        
        options = options.filter(option => {
          return option.operId != state.state.deleteItem
        })

            state.commit('setFilters', options)
            resolve(true)
          });
        } catch (error) {
          reject(error)
  
        }
      })
     
    },
  },
});
